import {gql} from '@apollo/client';
import {FRAGMENT_CLIENT_LIST} from '../Client/graphql';
import {FRAGMENT_TOPIC_LIST} from '../Topic/graphql';

export const FRAGMENT_TALK_LIST = gql`
  fragment TalkList on TalkType {
    id
    client1 {
      ...ClientList
    }
    client2 {
      ...ClientList
    }
    target1
    target2
    themeIds
    themeIndex
    topic {
      ...TopicList
    }
  }
  ${FRAGMENT_CLIENT_LIST}
  ${FRAGMENT_TOPIC_LIST}
`;

export const QUERY_TALK_DETAIL = gql`
  query TalkDetail($id: ID!) {
    talkDetail(id: $id) {
      ...TalkList
    }
  }
  ${FRAGMENT_TALK_LIST}
`;

export const MUTATION_TALK_SAVE = gql`
  mutation TalkSave($input: TalkSaveInput!) {
    talkSave(input: $input) {
      obj {
        ...TalkList
      }
      errors {
        field
        messages
      }
    }
  }
  ${FRAGMENT_TALK_LIST}
`;

export const MUTATION_TALK_TARGET = gql`
  mutation TalkTarget($input: TalkTargetInput!) {
    talkTarget(input: $input) {
      obj {
        ...TalkList
      }
      errors {
        field
        messages
      }
    }
  }
  ${FRAGMENT_TALK_LIST}
`;
